/* eslint-disable eqeqeq */
import React, { useCallback, useMemo, useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  // CardTitle,
} from "../../../components/ui/card";
import BootstrapTable from "react-bootstrap-table-next";
import {
  API,
  fileUpload,
  get,
  paymentMethods,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useEffect } from "react";
import {
  formatAccountNumber,
  formatBSBNumber,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import SearchInput from "../../../components/SearchInput";
import { debounce } from "lodash";
import Spin from "../../../components/Spin";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
// import ExpandABATransactions from "../../ABATransactions/ExpandABATransactions";
import Payments from "../../Payments/Payments";
// import CustomTooltip from "../../../components/CustomTooltip";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import AddEditPayment from "../../Payments/AddEditPayment";
import AddEditReceipt from "../../Receipts/AddEditReceipt";
import { useTrust } from "../../../lib/context/TrustContext";
import AddEditInvoicing from "../../Invoicing/AddEditInvoicing";
import moment from "moment";
import {
  LawyerConditon,
  InvoiceModuleConditon,
} from "../../../lib/PermissionConditions";
import ExpandReceipt from "../../Receipts/ExpandReceipt";
import RefundReceiptHistory from "../../Receipts/RefundReceiptHistory";
import CustomTooltip from "../../../components/CustomTooltip";
import { ClipboardList } from "lucide-react";

const SearchItem = ({
  item,
  removeSearchId,
  searchParams,
  trustId,
  setUpdatedResponse,
}) => {
  const { trustData } = useTrust();
  const { organizationData } = useOrganization();
  const [selectedItem, setSelectedItem] = useState("");
  const [data, setData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [searchParam, setSearchParam] = useState(
    searchParams ? searchParams : "",
  );
  const [searchParamData, setSearchParamData] = useState(
    searchParams ? searchParams : "",
  );
  const [showAddEditPaymentReceipt, setShowAddEditPaymentReceipt] =
    useState(false);

  const [receiptId, setReceiptId] = useState(null);

  const toggleShowAddEditPaymentReceipt = () => {
    setShowAddEditPaymentReceipt(!showAddEditPaymentReceipt);
  };

  const [showRefundHistory, setShowRefundHistory] = useState();

  const toggleShowRefundHistory = () => {
    setShowRefundHistory(!showRefundHistory);
  };

  const isAuctioner =
    InvoiceModuleConditon(organizationData) &&
    organizationData?.organizationData?.is_invoicing
      ? true
      : false;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    debouncedSave(nextValue);
  };

  const invoiceData = useCallback(
    (searchKeyWord) => {
      try {
        setIsDataLoading(true);
        setSearchParamData(searchKeyWord);
        if (searchKeyWord !== "") {
          get(
            API.GET_INVOICINGS +
              `?search=${searchKeyWord}&trust_id=${trustId}&limit=-1&bank_reconciliation=1`,
          ).then((response) => {
            setIsDataLoading(false);
            setData([]);
            const userData = response.data.data.data.map((user) => {
              return {
                ...user,
                key: user.id,
              };
            });
            setData(
              userData
                ? userData?.filter((item) => item?.is_reversed !== 1)
                : [],
            );
          });
        } else {
          setIsDataLoading(false);
          setData([]);
        }
      } catch (e) {
        setData([]);
        setIsDataLoading(false);
      }
    },
    [trustId],
  );

  const receiptData = useCallback(
    (searchKeyWord) => {
      try {
        setIsDataLoading(true);
        setSearchParamData(searchKeyWord);
        if (searchKeyWord !== "") {
          get(
            API.GET_RECEIPT +
              `?search=${searchKeyWord}&trust_id=${trustId}&limit=-1&bank_reconciliation=1`,
          ).then((response) => {
            setIsDataLoading(false);
            setData([]);
            const userData = response.data.data.data.map((user) => {
              return {
                ...user,
                key: user.record_type === 0 ? user.receipt_id : user.ato_id,
              };
            });
            setData(
              userData
                ? userData?.filter((item) => item?.is_reversed !== 1)
                : [],
            );
          });
        } else {
          setIsDataLoading(false);
          setData([]);
        }
      } catch (e) {
        setData([]);
        setIsDataLoading(false);
      }
    },
    [trustId],
  );

  const paymentData = useCallback(
    (searchKeyWord) => {
      try {
        setIsDataLoading(true);
        setSearchParamData(searchKeyWord);
        if (searchKeyWord !== "") {
          get(
            `${API.GET_ABA_LIST_DOWNLOAD}?search=${searchKeyWord}&trust_id=${trustId}&limit=-1&aba_file=0&bank_reconciliation=1`,
          ).then((response) => {
            setIsDataLoading(false);
            setData([]);
            const processData = response?.data?.data?.data.map((refund) => {
              return {
                ...refund,
                key: refund.id,
              };
            });
            setData(
              processData
                ? processData?.filter((item) => item?.is_reversed !== 1)
                : null,
            );
          });
        } else {
          setIsDataLoading(false);
          setData([]);
        }
      } catch (e) {
        setData([]);
        setIsDataLoading(false);
      }
    },
    [trustId],
  );

  const handleSaveProcessRefundSearch = async (record) => {
    try {
      setIsDataLoading(true);
      let selectedData;
      if (record) {
        selectedData = record;
      } else {
        selectedData = selectedItem;
      }
      if (item?.id) {
        const formData = new FormData();
        formData.append("aba_file_id", selectedData.id);

        formData.append("trust_id", trustId);
        if (record?.contact_id) {
          formData.append("contact_id", record?.contact_id);
        }
        formData.append("_method", "put");
        const response = await fileUpload(
          `${API.UPDATE_BANK_RECONCILIATION}/${item?.id}`,
          formData,
          {},
        );

        if (response.status === 200) {
          setIsDataLoading(false);
          setUpdatedResponse(response?.data?.data);
          removeSearchId(item?.id);
        }
      } else {
        setIsDataLoading(false);
        removeSearchId(item?.id);
      }
    } catch (error) {
      setIsDataLoading(false);
    }
  };

  const handleSaveSearch = async (record) => {
    try {
      setIsDataLoading(true);
      let selectedData;
      if (record) {
        selectedData = record;
      } else {
        selectedData = selectedItem;
      }
      if (item?.id) {
        const formData = new FormData();
        formData.append("trust_id", trustId);
        if (isAuctioner) {
          formData.append("invoice_id", selectedData.id);
        } else {
          formData.append("receipt_id", selectedData.id);
        }
        if (record?.contact_id) {
          formData.append("contact_id", record?.contact_id);
        }
        formData.append("_method", "put");

        const response = await fileUpload(
          `${API.UPDATE_BANK_RECONCILIATION}/${item?.id}`,
          formData,
        );

        if (response.status === 200) {
          setIsDataLoading(false);
          setUpdatedResponse(response?.data?.data);
          removeSearchId(item?.id);
        }
      } else {
        setIsDataLoading(false);
        removeSearchId(item?.id);
      }
    } catch (error) {
      setIsDataLoading(false);
    }
  };
  useEffect(() => {
    if (searchParam) {
      item?.base_type
        ? isAuctioner
          ? invoiceData(searchParam)
          : receiptData(searchParam)
        : paymentData(searchParam);
    }
  }, [
    item?.base_type,
    paymentData,
    receiptData,
    invoiceData,
    isAuctioner,
    searchParam,
  ]);

  const paymentGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: data[i]?.id,
        id: data[i]?.id,
        aba_file_id: data[i]?.aba_file_id,
        transaction_date: data[i]?.transaction_date
          ? data[i]?.transaction_date
          : "",

        name: data[i]?.multiple_payments
          ? `Multiple Payee`
          : data[i]?.contacts?.[0]
            ? `${formatSubcontractorName(
                data[i]?.contacts?.[0],
              )} - (${getModuleNamingBySlug(
                organizationData?.organizationData,
                "contacts",
                "C",
              )?.charAt(0)})`
            : data[i]?.vendors
              ? `${formatSubcontractorName(
                  data[i]?.vendors?.[0],
                )} - (${getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "vendors",
                  "V",
                )?.charAt(0)})`
              : "",
        bank_name: data[i]?.bank_name ? data[i]?.bank_name : "-",
        description: data[i]?.description ? data[i]?.description : "-",
        exc_gst_total_amount: data[i]?.total_amount
          ? "$" +
            formatNumber(
              Number(
                formatNumber(Number(data[i]?.total_amount)).replace(/,/g, "") /
                  1.1,
              ),
            )
          : `$0.00`,
        amount: data[i]?.amount
          ? "$" + formatNumber(Number(data[i]?.amount))
          : `$0.00`,
        total_amount: data[i]?.total_amount ? (
          <b>{`$${formatNumber(Number(data[i]?.total_amount))}`}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),

        total_amount_exc: data[i]?.total_amount_exc ? (
          <b>{`$${formatNumber(Number(data[i]?.total_amount_exc))}`}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        total_tax_amount: data[i]?.total_tax_amount ? (
          <b>{`$${formatNumber(Number(data[i]?.total_tax_amount))}`}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        fees: data[i]?.fees
          ? "$" + formatNumber(Number(data[i]?.fees))
          : `$0.00`,

        file: data[i]?.file ? `${data[i]?.file?.split("/").slice(-1)}` : "",
        payments: data[i]?.payment ? data[i]?.payment : "",
        is_reversed: data[i]?.is_reversed,
      });
    }
    return items;
  };
  const paymentTableData = paymentGenerator(data?.length);

  const receiptsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: data[i]?.id,
        id: data[i]?.id,
        received_date: data[i]?.received_date ? data[i]?.received_date : "-",
        transaction_date: data[i]?.transaction_date
          ? data[i]?.transaction_date
          : "-",

        payment_method: data[i]?.payment_method
          ? data[i]?.payment_method == "5"
            ? "JE"
            : paymentMethods?.find(
                (item) => item.value === Number(data[i]?.payment_method),
              )?.label
          : "-",
        payeer:
          data[i]?.payeer === 1
            ? data[i]?.vendor
              ? `${formatSubcontractorName(data[i]?.vendor)} - (${getModuleNamingBySlug(
                  organizationData,
                  "vendors",
                  "V",
                )?.charAt(0)})`
              : "-"
            : data[i]?.contact
              ? `${formatSubcontractorName(data[i]?.contact)} - (${getModuleNamingBySlug(
                  organizationData,
                  "contacts",
                  "C",
                )?.charAt(0)})`
              : "-",
        receipt_number: data[i]?.receipt_number ? data[i]?.receipt_number : "-",
        invoice_number: data[i]?.invoice_number ? data[i]?.invoice_number : "-",
        amount: data[i]?.original_amount ? (
          <b>${formatNumber(Number(data[i]?.original_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        amount_exc: data[i]?.total_amount_exc ? (
          <b>${formatNumber(Number(data[i]?.total_amount_exc))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        // tax_amount:
        //   data[i]?.amount && data[i]?.tax === "1" ? (
        //     <CustomTooltip
        //       message={
        //         data[i]?.tax === "1" &&
        //         ` (${data[i]?.sub_asset?.tax_percentage}%)`
        //       }
        //     >
        //       <b>
        //         $
        //         {formatNumber(
        //           Number(
        //             CalculateGST(
        //               "1",
        //               data[i]?.tax,
        //               data[i]?.amount,
        //               data[i]?.sub_asset?.tax_percentage
        //             )
        //           )
        //         )}
        //       </b>
        //     </CustomTooltip>
        //   ) : (
        //     <b>{"$0.00"}</b>
        //   ),
        tax_amount: data[i]?.total_tax_amount ? (
          <b>${formatNumber(Number(data[i]?.total_tax_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        bsb: data[i]?.bsb ? formatBSBNumber(data[i]?.bsb) : "-",
        account_number: data[i]?.account_number
          ? formatAccountNumber(data[i]?.account_number)
          : "-",
        description: data[i]?.description ? data[i]?.description : "-",
        vendor: data[i]?.vendor
          ? formatSubcontractorName(data[i]?.vendor)
          : "-",
        asset: data[i]?.asset?.name ? data[i]?.asset?.name : "-",
        sub_asset: data[i]?.sub_asset?.name ? data[i]?.sub_asset?.name : "-",
        contract: data[i]?.contract ? data[i]?.contract?.contract_number : "-",
        contact: data[i]?.contact
          ? formatSubcontractorName(data[i]?.contact)
          : "-",
        job: data[i]?.ts_job?.code ? data[i]?.ts_job?.code : "-",
        task: data[i]?.ts_task?.code ? data[i]?.ts_task?.code : "-",
        file_note: data[i]?.file_note ? data[i]?.file_note : "-",
        is_reversed: data[i]?.is_reversed,
        receiptData: data[i]?.receipt_detail ? data[i]?.receipt_detail : "",
        remaining_balance:
          data[i]?.receipt_detail?.length > 0 ? (
            <b>
              $
              {formatNumber(
                Number(
                  data[i]?.receipt_detail?.reduce(
                    (sum, item) => sum + Number(item?.remaining_balance || 0),
                    0,
                  ),
                ),
              ) || "0.00"}
            </b>
          ) : (
            <b>{"$0.00"}</b>
          ),
        action: (
          <span className="flex items-center gap-2 justify-center">
            <CustomTooltip message={"Refund History"}>
              <span>
                {/* <FontAwesomeIcon
                          icon={faMoneyBillTransfer}
                          size="1x"
                          onClick={() => {
                            toggleShowRefund();
                            setReceiptId(id);
                          }}
                        /> */}
                <div className="h-4 w-4 dark:invert">
                  <ClipboardList
                    size={16}
                    onClick={() => {
                      toggleShowRefundHistory();
                      setReceiptId(data[i]?.id);
                    }}
                  />
                </div>
              </span>
            </CustomTooltip>
          </span>
        ),
        // ...data[i],
      });
    }
    return items;
  };
  const receiptTableData = receiptsGenerator(data?.length);

  const invoicesGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: data[i]?.id,
        id: data[i]?.id,
        date: data[i]?.date
          ? moment(data[i]?.date, "YYYY-MM-DD").format("DD-MM-YYYY")
          : "-",
        due_date: data[i]?.due_date
          ? moment(data[i]?.due_date, "YYYY-MM-DD").format("DD-MM-YYYY")
          : "-",
        note: data[i]?.note ? data[i]?.note : "-",
        invoice_number: data[i]?.invoice_number ? data[i]?.invoice_number : "-",
        description: data[i]?.description ? data[i]?.description : "-",
        remaining_balance: data[i]?.remaining_balance ? (
          <b className="text-green-500">
            ${formatNumber(Number(data[i]?.remaining_balance))}
          </b>
        ) : (
          <b className="text-green-500">{"$0.00"}</b>
        ),
        amount_exc: data[i]?.total_amount ? (
          <>${formatNumber(Number(data[i]?.total_amount))}</>
        ) : (
          <>{"$0.00"}</>
        ),
        tax_amount: data[i]?.total_gst_amount ? (
          <>${formatNumber(Number(data[i]?.total_gst_amount))}</>
        ) : (
          <>{"$0.00"}</>
        ),
        net_amount: data[i]?.total_net_amount ? (
          <b>${formatNumber(Number(data[i]?.total_net_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        contact: data[i]?.contact
          ? formatSubcontractorName(data[i]?.contact)
          : "-",
        is_reversed: data[i]?.is_reversed,
        // ...data[i],
      });
    }
    return items;
  };

  const invoiceTableData = invoicesGenerator(data?.length);

  const columns = item?.base_type
    ? isAuctioner
      ? [
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            text: "Date",
            dataField: "date",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "due_date",
            text: "Due Date",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "note",
            text: "Note",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "contact",
            text: `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer",
            )}`,
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "invoice_number",
            text: "Invoice Number",
          },
          {
            headerClasses: THClasses,
            classes: TDClasses,
            dataField: "amount_exc",
            text: "Amount (Exc)",
          },
          {
            headerClasses: THClasses,
            classes: TDClasses,
            dataField: "tax_amount",
            text: "Tax",
          },
          {
            headerClasses: THClasses,
            classes: TDClasses,
            dataField: "net_amount",
            text: "Net Amount (Inc)",
          },
          {
            headerClasses: THClasses,
            classes: TDClasses,
            dataField: "remaining_balance",
            text: "Remaining Balance",
          },
        ]
      : [
          // {
          //   headerClasses: `${THClasses} !h-[25px]`,
          //   classes: `${TDClasses} whitespace-normal text-wrap`,
          //   text: "Transaction Date",
          //   dataField: "transaction_date",
          // },
          // {
          //   headerClasses: `${THClasses} !h-[25px]`,
          //   classes: `${TDClasses} whitespace-normal text-wrap`,
          //   dataField: "received_date",
          //   text: "Received Date",
          // },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "transaction_date",
            text: "Transaction Date",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            // dataField: "contact",
            // text: `${getModuleNamingBySlug(
            //   organizationData?.organizationData,
            //   "contacts",
            //   "Customer",
            // )}`,
            dataField: "payeer",
            text: "Payer",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "sub_asset",
            text: `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "sub-assets",
              "Sub Asset",
            )}`,
          },

          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "receipt_number",
            text: "Receipt Number",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "invoice_number",
            text: "Invoice Number",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "file_note",
            // text: "File Note",
            text: LawyerConditon(organizationData)
              ? "Matter Reference"
              : "File Note",
          },
          {
            headerClasses: `${THClasses} !h-[25px]`,
            classes: `${TDClasses} whitespace-normal text-wrap`,
            dataField: "payment_method",
            text: "Payment Method",
          },
          {
            headerClasses: THClasses,
            classes: TDClasses,
            dataField: "amount",
            text: "Amount (Inc)",
          },

          {
            headerClasses: THClasses,
            classes: TDClasses,
            dataField: "remaining_balance",
            text: "Remaining Balance",
          },
          {
            headerClasses: THClasses,
            classes: TDClasses,
            dataField: "action",
            text: "Action",
            align: "center",
            headerAlign: "center",
            style: { width: "127px" },
          },
          // {
          //   headerClasses: THClasses,
          //   classes: TDClasses,
          //   dataField: "amount_exc",
          //   text: "Amount (Exc)",
          // },
          // {
          //   headerClasses: THClasses,
          //   classes: TDClasses,
          //   dataField: "tax_amount",
          //   text: "Tax",
          // },
        ]
    : [
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "transaction_date",
          text: "Transaction Date",
        },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "name",
          text: "Payee",
        },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "bank_name",
          text: "Bank Name",
        },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "description",
          // text: "Description",
          text: LawyerConditon(organizationData)
            ? "Matter Description"
            : "Description",
        },
        // {
        //   headerClasses: `${THClasses} !h-[25px]`,
        //   classes: `${TDClasses} whitespace-normal text-wrap`,
        //   dataField: "amount",
        //   text: "Amount",
        // },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "fees",
          text: "Fees",
        },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "total_amount",
          text: "Total Amount",
        },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "total_amount",
          text: "Total Amount (Inc)",
        },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "total_amount_exc",
          text: "Total Amount (Exc)",
        },
        {
          headerClasses: `${THClasses} !h-[25px]`,
          classes: `${TDClasses} whitespace-normal text-wrap`,
          dataField: "total_tax_amount",
          text: "Total Tax",
        },
      ];

  const getNonSelectableRows = (data) => {
    let disable = [];
    for (let i = 0; i < data?.length; i++) {
      if (item?.base_type === 0) {
        if (Number(data[i]?.total_amount) !== Number(item?.amount)) {
          disable.push(data[i]?.id);
        }
      } else {
        if (isAuctioner) {
          if (Number(data[i]?.remaining_balance) !== Number(item?.amount)) {
            disable.push(data[i]?.id);
          }
        } else {
          if (Number(data[i]?.original_amount) !== Number(item?.amount)) {
            disable.push(data[i]?.id);
          }
        }
      }
    }
    return disable;
  };
  const selectRow = {
    mode: "radio", // single row selection
    clickToSelect: true,
    onSelect: (row) => {
      setSelectedItem(row);
      // item?.base_type === 0
      //   ? handleSaveProcessRefundSearch(row)
      //   : handleSaveSearch(row);
    },
    nonSelectable: getNonSelectableRows(data),
  };

  const expandRow = {
    renderer: (row) => (
      <>
        {/* <ExpandABATransactions id={row?.id} expandList={true} /> */}
        {item?.base_type ? (
          <ExpandReceipt expandData={row?.receiptData} />
        ) : (
          <Payments expandList={true} paymentData={row?.payments} />
        )}
      </>
    ),
    onlyOneExpanding: false,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: `${THClasses} !h-[25px]`,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: `${TDClasses} whitespace-normal text-wrap`,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  const isButtonDisabled = useMemo(() => {
    if (!data?.length) return true;
    if (!selectedItem) return true;
    return false;
  }, [data?.length, selectedItem]);

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      let notIds = getNonSelectableRows(data);
      if (!notIds.includes(row?.id)) {
        item?.base_type === 0
          ? handleSaveProcessRefundSearch(selectedItem)
          : handleSaveSearch(selectedItem);
      }
    },
  };

  return (
    <Card className="mt-4 rounded-md bg-muted xl:col-span-2 col-span-4 h-fit border-webPrimary">
      <CardHeader className="p-0 pb-0 bg-webPrimary rounded-ss-md rounded-se-md text-white">
        <div className="w-full rounded-md rounded-b-none px-2 py-1.5 text-sm font-bold border-b">
          <div className="flex items-center justify-between">
            {item?.base_type
              ? isAuctioner
                ? "Trust Invoice"
                : "Trust Receipt"
              : "Trust Payment"}
            <div className="flex items-center gap-2">
              <Button
                onClick={() => toggleShowAddEditPaymentReceipt()}
                className="hover:cursor-pointer dark:hover:bg-white dark:hover:text-muted hover:bg-black hover:text-white dark:text-white text-black bg-muted rounded-sm flex items-center justify-center h-5 p-2"
              >
                {item?.base_type
                  ? isAuctioner
                    ? "Enter Trust Invoice"
                    : "Enter Trust Receipt"
                  : "Enter Trust Payment"}
              </Button>
              <Button
                className="disabled:cursor-not-allowed disabled:hover:cursor-not-allowed hover:cursor-pointer dark:hover:bg-white dark:hover:text-muted hover:bg-black hover:text-white dark:text-white text-black bg-muted rounded-sm flex items-center justify-center  h-5 p-2"
                onClick={() => {
                  item?.base_type === 0
                    ? handleSaveProcessRefundSearch(selectedItem)
                    : handleSaveSearch(selectedItem);
                }}
                size="sm"
                disabled={isButtonDisabled}
              >
                {/* <Check className="h-4 w-4" /> */}
                OK
              </Button>
              <Button
                className="hover:cursor-pointer dark:hover:bg-white dark:hover:text-muted hover:bg-black hover:text-white dark:text-white text-black bg-muted rounded-sm flex items-center justify-center h-5 p-2"
                onClick={() => removeSearchId(item?.id)}
              >
                {/* <XIcon className="h-4 w-4" /> */}
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-3 py-2 relative">
        {isDataLoading && <Spin expand={true} />}
        <div className="flex justify-between pb-2">
          <SearchInput
            searchParamData={searchParamData}
            handleSearchChange={handleSearchChange}
            clearable={false}
          />
        </div>

        <div className="table-body-class bg-background rounded-md">
          <BootstrapTable
            keyField="key"
            remote
            data={
              item?.base_type
                ? isAuctioner
                  ? invoiceTableData
                  : receiptTableData
                : paymentTableData
            }
            columns={columns}
            rowClasses={`${TRClasses} hover:!bg-background`}
            noDataIndication="No Data Found"
            classes={TableClasses}
            loading={isDataLoading}
            selectRow={selectRow}
            wrapperClasses={`${TableWrapClasses}`}
            expandRow={expandRow}
            rowEvents={rowEvents}
          />
        </div>
        <ResponsiveDrawerForm
          description={""}
          title={
            item?.base_type
              ? isAuctioner
                ? "Add Invoice"
                : "Add Receipt"
              : "Add Payment"
          }
          handleOpen={() => {}}
          handleClose={() => {
            setShowAddEditPaymentReceipt(false);
          }}
          buttonText={""}
          open={showAddEditPaymentReceipt}
          buttonClassName={""}
          setOpen={setShowAddEditPaymentReceipt}
          className={"md:max-w-[95vw] md:max-h-[95vh]"}
          mobileCancelHidden={true}
          write={true}
          popupType={"bank-reconciliations"}
        >
          {item?.base_type ? (
            isAuctioner ? (
              <AddEditInvoicing
                toggleShowAddEditInvoicing={toggleShowAddEditPaymentReceipt}
                trustId={trustId}
                trustData={trustData}
                fetchInvoicingData={() => invoiceData(searchParam)}
              />
            ) : (
              <AddEditReceipt
                toggleShowAddEditReceipt={toggleShowAddEditPaymentReceipt}
                trustId={trustId}
                fetchReceiptData={() => receiptData(searchParam)}
                popupType={"bank-reconciliations"}
              />
            )
          ) : (
            <AddEditPayment
              toggleShowAddEditPayment={toggleShowAddEditPaymentReceipt}
              trustId={trustId}
              fetchPaymentData={() => paymentData(searchParam)}
            />
          )}
        </ResponsiveDrawerForm>

        <ResponsiveDrawerForm
          description={""}
          title={"Refund History"}
          handleOpen={() => {}}
          handleClose={() => {}}
          className={"sm:max-w-[50vw] max:min-w-screen"}
          open={showRefundHistory}
          buttonClassName={""}
          setOpen={setShowRefundHistory}
          read={true}
          write={true}
          popupType={"bank-reconciliations"}
          mobileCancelHidden={true}
        >
          <>
            <RefundReceiptHistory receiptId={receiptId} />
          </>
        </ResponsiveDrawerForm>
      </CardContent>
    </Card>
  );
};

export default SearchItem;
